module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABlSURBVDhP3YxBCoAwDASDH/V3XvyFRx/hB7z2HiEkYJYNtEgvDsxl06lMYdkO7dWTDHtY6UmGPaz0JMMeVnrygfW89C3bUAsDdsQNtTBgR9xQCwN2xA21cCr73TT0aYwffNCPyAO1/CWoqO6BhgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/currencyIcon/FTT.png
// module id = doKf
// module chunks = 1